import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/BULK`;

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments?domain=${SYSTEM_DOMAIN}&status=UNASSIGNED`;

export const CUSTOM_DATE_FORM_NAME = 'UNASSIGNED_DATE_FILTER';

export const ROUTES = {
  ROOT: '/bulk',
};
